import React, { useEffect, useState } from "react";
import { getMyInvitations, respondInvitation } from "../../services/user.service";
import Swal from "sweetalert2";
import { handleServerValidations } from "../../../../utils/commonfunction";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function StaffInvitations() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [invitations, setInvitations] = useState([]);

    useEffect(() => {
        fetchInvitations();
    }, []);

    const fetchInvitations = async () => {
        try {
            const resp = await getMyInvitations();
            if (resp.success) {
                setInvitations(resp.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleRespond = async (staffId, action) => {
        try {
            const resp = await respondInvitation({ staff_id: staffId, action });
            if (resp.success) {
                Swal.fire({ icon: "success", text: t('advertiser.staff_invitations.invitation_responded', { action: action.toLowerCase() }) });
                fetchInvitations();
            } else {
                Swal.fire({ icon: "error", text: handleServerValidations(resp) });
            }
        } catch (err) {
            Swal.fire({ icon: "error", text: t('common.error') });
        }
    };

    const pendingInvites = invitations.filter(inv => inv.status === 'Pending');
    const acceptedInvites = invitations.filter(inv => inv.status === 'Accepted');

    if (loading) {
        return (
            <div className="flex items-center justify-center py-24">
                <div className="w-16 h-16 border-4 border-[#FF63B5] border-t-transparent rounded-full animate-spin"></div>
            </div>
        );
    }

    const InviteCard = ({ invite, isPending }) => {
        const seller = invite.seller_id;
        console.log(seller, "dekho=>>");

        return (
            <div className="bg-white p-6 rounded-xl shadow-[0px_2px_15px_rgba(0,0,0,0.04)] border border-gray-100 flex flex-col items-center">
                <div className="h-14 w-14 rounded-full overflow-hidden bg-gray-200 mb-3">
                    <img 
                        src={seller?.profile_image || "/images/User.png"} 
                        onError={(e) => { e.target.onerror = null; e.target.src = '/images/User.png'; }}
                        alt="seller" 
                        className="w-full h-full object-cover" 
                    />
                </div>
                <h3 className="text-base font-bold text-gray-900">{seller?.name || t('common.unnamed_store')}</h3>
                <p className="text-xs text-gray-500 mb-5">{seller?.store_name}</p>

                {isPending ? (
                    <div className="w-full grid grid-cols-2 gap-3">
                        <button
                            onClick={() => handleRespond(invite._id, "Accept")}
                            className="w-full py-2 bg-[#FF63B5] text-white rounded-lg text-sm font-medium hover:bg-pink-600 transition"
                        >
                            {t('advertiser.staff_invitations.accept')}
                        </button>
                        <button
                            onClick={() => handleRespond(invite._id, "Reject")}
                            className="w-full py-2 border border-[#FF63B5] text-[#FF63B5] rounded-lg text-sm font-medium hover:bg-pink-50 transition"
                        >
                            {t('advertiser.staff_invitations.reject')}
                        </button>
                    </div>
                ) : (
                    <div className="w-full flex flex-col gap-3">
                        <button
                            onClick={() => navigate('/user/assigned-streams', {
                                state: {
                                    seller_id: seller?._id,
                                    seller_name: seller?.store_name || seller?.name || "The Store",
                                    permissions: invite.permissions
                                }
                            })}
                            className="w-full py-2 bg-[#FF63B5] text-white rounded-lg text-sm font-medium hover:bg-pink-600 transition"
                        >
                            {t('advertiser.staff_invitations.view_streams')}
                        </button>
                        
                        {invite.permissions && invite.permissions.includes("create_product") && (
                            <button
                                onClick={() => navigate('/user/staff-products', {
                                    state: {
                                        seller_id: seller?._id,
                                        seller_name: seller?.store_name || seller?.name || "The Store",
                                        permissions: invite.permissions
                                    }
                                })}
                                className="w-full py-2 border border-[#FF63B5] text-[#FF63B5] rounded-lg text-sm font-medium hover:bg-pink-50 transition"
                            >
                                Manage Products
                            </button>
                        )}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="p-6 max-w-6xl mx-auto h-[calc(100vh-250px)] overflow-y-auto">
            <h2 className="headings-h2 text-zinc-950 mb-6">{t('advertiser.staff_invitations.heading')}</h2>

            {pendingInvites.length === 0 && <p className="text-gray-500 mb-8 italic">{t('advertiser.staff_invitations.no_pending')}</p>}

            {pendingInvites.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-10">
                    {pendingInvites.map(inv => <InviteCard key={inv._id} invite={inv} isPending={true} />)}
                </div>
            )}

            <h2 className="headings-h2 text-zinc-950 mb-6 mt-10">{t('advertiser.staff_invitations.access_heading')}</h2>

            {acceptedInvites.length === 0 && <p className="text-gray-500 mb-8 italic">{t('advertiser.staff_invitations.no_active')}</p>}

            {acceptedInvites.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {acceptedInvites.map(inv => <InviteCard key={inv._id} invite={inv} isPending={false} />)}
                </div>
            )}
        </div>
    );
}
